export default __webpack_public_path__ + "static/media/olusojiadejuwon.9a869084.png";